import React from 'react';
import { Link } from 'react-router-dom';
import Sticky from 'react-stickynode';
import Panel from '../../../components/Panel';
import ROUTE_NAME from '../../../routes/RouteName';

import { useDict } from '../../../contexts/LanguageContext';
import useWindowSize from '../../../hooks/useWindowSize';
import { BootstrapBreakpoints } from '../../../utils/constants';

const Navigation = (props) => {
    const { active, onDownloadUserGuide } = props;

    const dict = useDict();

    const { width } = useWindowSize();

    const isMobile = width <= BootstrapBreakpoints.MD;

    return (
        <Sticky top={isMobile ? 60 : 65} innerActiveClass="panel--sticky">
            <Panel
                title={dict.sections}
                colClassName="w-100 px-0"
                panelClassName="faq-panel"
                classname="faq-panel-body"
                collapsable={isMobile}
            >
                <Link
                    to={ROUTE_NAME.FAQ_GENERAL_ENQUIRIES}
                    className={`documentation__nav-link${active === 'generalenquiries'
                        ? ' documentation__nav--active'
                        : ''
                        }`}
                >
                    {dict.generalEnquiries}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_ELIGIBILITY}
                    className={`documentation__nav-link${active === 'eligibility' ||
                        active === 'registrationprocess' ||
                        active === 'investnow' ||
                        active === 'typesofinvestmentnotes' ||
                        active === 'repayments'
                        ? ' documentation__nav--active'
                        : ''
                        }`}
                >
                    {dict.financingPlatform}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_ELIGIBILITY}
                    className={`documentation__nav-link documentation__nav-sublink ${active === 'eligibility'
                        ? ' documentation__nav--active'
                        : ''
                        }`}
                >
                    {dict.eligibility}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_REGISTRATION_PROCESS}
                    className={`documentation__nav-link documentation__nav-sublink ${active === 'registrationprocess'
                        ? ' documentation__nav--active'
                        : ''
                        }`}
                >
                    {dict.registrationProcess}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_INVEST_NOW}
                    className={`documentation__nav-link documentation__nav-sublink ${active === 'investnow' ? ' documentation__nav--active' : ''
                        }`}
                >
                    {dict.investNowFaq}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_TYPES_OF_INVESTMENT_NOTES}
                    className={`documentation__nav-link documentation__nav-sublink ${active === 'typesofinvestmentnotes' ? ' documentation__nav--active' : ''
                        }`}
                >
                    {dict.typesOfInvestmentNotes}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_REPAYMENTS}
                    className={`documentation__nav-link documentation__nav-sublink ${active === 'repayments' ? ' documentation__nav--active' : ''
                        }`}
                >
                    {dict.repayments}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_INVESTMENT_MEMOS}
                    className={`documentation__nav-link ${active === 'investmentmemos' ? ' documentation__nav--active' : ''
                        }`}
                >
                    {dict.investmentMemos}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_RISK_MANAGEMENT}
                    className={`documentation__nav-link ${active === 'riskmanagement' ? ' documentation__nav--active' : ''
                        }`}
                >
                    {dict.riskManagement}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_FEES_AND_CHARGES}
                    className={`documentation__nav-link ${active === 'feesandcharges' ? ' documentation__nav--active' : ''
                        }`}
                >
                    {dict.feesAndCharges}
                </Link>
                <Link
                    to={ROUTE_NAME.FAQ_DEFAULT_AND_RECOVERY}
                    className={`documentation__nav-link ${active === 'defaultandrecovery' ? ' documentation__nav--active' : ''
                        }`}
                >
                    {dict.defaultAndRecovery}
                </Link>
                {/* <span
                    aria-hidden="true"
                    className="documentation__nav-link2"
                    style={{ fontWeight: 'bold' }}
                    onClick={onDownloadUserGuide}
                >
                    {dict.downloadUserGuide}
                </span> */}
            </Panel>
        </Sticky>
    );
};

export default Navigation;
